
















import { Component, Prop, Emit } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'

import { dateTimeToDisplay } from '@/utils/dateTime'
import { Policy } from '@/modules/Policy/interfaces/policy'
import { AcordForm } from '@/modules/AcordForm/interfaces/acord-form'
import FoldingCard from '@/components/FoldingCard.vue'
import AppFileUploader from '@/components/AppFileUploader.vue'
import AppDialog from '@/components/AppDialog.vue'
import S3Handler from '@/mixins/s3'
import AcordFormDialog from '@/components/AcordFormDialog.vue'
import AcordFormList from '@/components/AcordFormList.vue'

@Component({
  components: {
    FoldingCard,
    AppFileUploader,
    AppDialog,
    AcordFormDialog,
    AcordFormList
  }
})
export default class PolicyAcordForm extends mixins(S3Handler) {
  @Prop({ type: Object as () => Policy }) readonly policy!: Policy

  dateTimeToDisplay = dateTimeToDisplay

  acordFormDialog = {
    show: false
  }

  get acordForms () {
    if (!this.policy) {
      return []
    }

    const list = this.policy.acordForms.concat()

    list.sort(function (a: AcordForm, b: AcordForm) {
      return b.version - a.version
    })

    const groupedObj = this.$R.groupBy((file: AcordForm) => {
      return file.acordFormId
    })(list)

    let acordList: AcordForm[] = []

    const diff = (a: string, b: string) => { return Number(b) - Number(a) }

    for (const key of this.$R.sort(diff, this.$R.keys(groupedObj))) {
      acordList = [...groupedObj[key], ...acordList]
    }

    return acordList
  }

  @Emit('success')
  onSuccess () {
    // do nothing
  }

  showAcordFormDialog (e: Event) {
    e.preventDefault()
    e.stopPropagation()
    this.acordFormDialog.show = true
  }
  hideAcordFormDialog () {
    this.acordFormDialog.show = false
  }
}
